import { Progress } from "@tree-company/mjp-shared";
import translate from "../locales";
import { usePage } from "@tree-company/tree-query";
import clsx from "clsx";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

function stepForPageKey(key) {
  if (key.startsWith("action")) {
    return 1;
  } else if (key.startsWith("comment") || key === "name") {
    return 2;
  } else if (key === "sociodemo") {
    return 3;
  } else if (key === "like" || key === "optin") {
    return 4;
  }
}

export function PageComponent({
  handleSave,
  page,
  children,
  onPreviousPage,
  className,
}) {
  const { theme } = useParams();
  const { title, description, htmlAttributes, key } = usePage(page);

  // Make sure the browsers back button has the same effect as our back button
  useEffect(() => {
    // If the previous history entry was a string, we already track history within the form
    // in that case, we can use `replaceState`
    // If not, we need to use `pushState` so that we can distinguish our history states from react router dom
    if (typeof window.history.state === "string") {
      window.history.replaceState(key, "", window.location.toString());
    } else {
      window.history.pushState(key, "", window.location.toString());
    }

    const goBack = (event) => {
      event.preventDefault();
      onPreviousPage();
    };
    window.addEventListener("popstate", goBack, { once: true });

    return () => window.removeEventListener("popstate", goBack, { once: true });
  }, [key]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [key]);

  return (
    <main className={clsx("survey-page", className, htmlAttributes.class)}>
      <form action="" className="survey-page__form" onSubmit={handleSave}>
        <Progress
          onBackButton={onPreviousPage}
          step={stepForPageKey(key)}
          title={translate([theme, "name"])}
          prevAria={translate(["general", "prev_page_aria"])}
        />
        {(title || description) && (
          <div className="survey-page__intro">
            {title && <h1 className="survey-page__title">{title}</h1>}
            {description && <p className="survey-page__text">{description}</p>}
          </div>
        )}

        {children}

        <button className="survey-page__action">
          {translate(["general", "next_page"])}
        </button>
      </form>
    </main>
  );
}
